import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 40,
  },
  lottieView: {
    height: 180,
  },
  textContainer: {
    paddingTop: 12.5,
    paddingBottom: 70,
  },
  text: theme => ({
    color: theme.colors.loadingTextColor,
    fontSize: 16.6,
    lineHeight: 22.2,
  }),
});
